const Deferred = () => {
  let _canceled = false
  let _resolve
  let _reject

  const _promise = new Promise((resolve, reject) => {
    _resolve = (value) => !_canceled && resolve(value)
    _reject = (value) => !_canceled && reject(value)
  })

  return {
    cancel: () => {
      _canceled = true
    },
    canceled: _canceled,
    resolve: (val) => _resolve(val),
    reject: (val) => _reject(val),
    then: (onFulfilled, onRejected) => _promise.then(onFulfilled, onRejected),
  }
}

export default Deferred
